import { useTranslation } from "react-i18next";
import QuantitySelector from "../QuantitySelector/QuantitySelector";
import { PLACEHOLDER_IMAGES } from "../../../utility/placeholders";
import "./CartItem.scss";

const CartItem = ({ item, quantity, onQuantityChange, onRemove }) => {
  const { t } = useTranslation("marketplace");
  const hasQuantitySelector = item.hasQuantitySelector !== false;

  return (
    <div className="cart-item">
      <div className="cart-item__image-container">
        <img
          src={item.imageUrl}
          alt={item.name}
          draggable={false}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = PLACEHOLDER_IMAGES.CARD;
          }}
        />
      </div>

      <div className="cart-item__content">
        {item.providerName && <span className="cart-item__provider">{item.providerName}</span>}
        <h3 className="cart-item__name">{item.name}</h3>
        <p className="cart-item__description">{item.description}</p>
        {item.providerMessage && (
          <div className="cart-item__provider-message">{item.providerMessage}</div>
        )}
      </div>

      <div className="cart-item__controls">
        {hasQuantitySelector && (
          <div className="cart-item__qty">
            <QuantitySelector
              value={quantity}
              onChange={(newQty) => onQuantityChange(item.id, newQty)}
              min={1}
            />
          </div>
        )}

        <button
          className="cart-item__remove-btn"
          onClick={() => onRemove(item.id)}
          title={t("cart.remove_item", { defaultValue: "Supprimer l'article" })}
          aria-label={t("cart.remove_item", { defaultValue: "Supprimer l'article" })}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default CartItem;
